module.exports = __webpack_public_path__ + "fonts/nanumbarungothic-webfont.852d05e2.woff2";